import { PatientInfo } from '@s/pages/for-patients/patient-journeys.tsx';
import * as React from 'react';
export default {
  PatientInfo,
  React
};